import * as React from 'react'

import Svg, { ClipPath, Defs, G, Path } from 'react-native-svg'

import { IconProps } from '../icons'

const ApplicationDoneFilled = ({
  size = 16,
  color = '#000',
  ...props
}: IconProps) => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <G fill="#0E4B28" clipPath="url(#a)">
      <Path d="M10.533 5.246a.535.535 0 0 0-.534-.533H4.666a.535.535 0 0 0-.533.533c0 .294.24.534.533.534H10c.294 0 .534-.24.534-.534ZM4.666 7.04a.535.535 0 0 0-.533.533c0 .294.24.534.533.534h2.48a.535.535 0 0 0 0-1.067h-2.48Z" />
      <Path d="M6.904 12.913h-2.82a1.034 1.034 0 0 1-1.033-1.033V4.086c0-.573.467-1.033 1.033-1.033h6.487c.567 0 1.033.467 1.033 1.033v3.18c.387.134.747.334 1.067.574V4.086a2.1 2.1 0 0 0-2.1-2.1H4.084a2.1 2.1 0 0 0-2.1 2.1v7.794c0 1.16.94 2.1 2.1 2.1h3.707c-.36-.3-.66-.66-.893-1.067h.006Z" />
      <Path d="M10.533 7.706A3.36 3.36 0 0 0 7.18 11.06a3.36 3.36 0 0 0 3.353 3.354 3.36 3.36 0 0 0 3.353-3.354 3.36 3.36 0 0 0-3.353-3.353Zm0 5.773a2.424 2.424 0 0 1-2.42-2.42 2.424 2.424 0 0 1 2.42-2.42 2.424 2.424 0 0 1 2.42 2.42 2.424 2.424 0 0 1-2.42 2.42Z" />
      <Path d="M12.104 10.053a.465.465 0 0 0-.66.007l-1.34 1.373-.433-.5a.472.472 0 0 0-.66-.046.472.472 0 0 0-.047.66l.767.886c.087.1.207.16.34.16h.013a.474.474 0 0 0 .334-.14l1.7-1.733a.465.465 0 0 0-.007-.66l-.007-.007Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill={color} d="M0 0h16v16H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)
export default ApplicationDoneFilled
